export default __webpack_public_path__ + "static/media/storageUnit1-afterB-2048w.dbacdd86.avif";